import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@/server/root';
import { trpcLinks } from './links';

export const api = createTRPCReact<AppRouter>();

export const trpcClient = api.createClient({
	links: trpcLinks,
});
